/*
  Computer Citi — On-Site Assessment estimator
  Matches a customer's description against ONSITE_KB and returns the best services.
  No need to edit this file; prices and keywords live in onsite-knowledge-base.js.
*/
(function (root) {
  function normalize(text) {
    return String(text || "")
      .toLowerCase()
      .replace(/[’']/g, "")        // won't -> wont
      .replace(/wi-fi/g, "wifi")
      .replace(/[^a-z0-9+\s]/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  function estimate(text, kb) {
    var clean = normalize(text);
    if (clean.length < 3 || !kb || !kb.services) return [];
    var padded = " " + clean + " ";
    var tokens = clean.split(" ");
    var results = [];

    kb.services.forEach(function (svc) {
      var score = 0;
      var hits = [];
      (svc.keywords || []).forEach(function (kw) {
        var k = normalize(kw);
        if (!k) return;
        if (k.indexOf(" ") !== -1) {
          // Phrase: exact phrase match, scored by length (more specific = higher)
          if (padded.indexOf(" " + k + " ") !== -1) {
            score += 3 + k.split(" ").length;
            hits.push(kw);
          }
        } else if (tokens.indexOf(k) !== -1) {
          score += 3;
          hits.push(kw);
        } else if (k.length >= 4 && tokens.some(function (t) { return t.indexOf(k) === 0; })) {
          // Prefix match: "print" matches "printing", "freez" style stems
          score += 2;
          hits.push(kw);
        }
      });
      if (score > 0) results.push({ service: svc, score: score, hits: hits });
    });

    if (!results.length) return [];
    results.sort(function (a, b) { return b.score - a.score; });
    var floor = Math.max(kb.minScore || 3, results[0].score * 0.25);
    return results
      .filter(function (r) { return r.score >= floor; })
      .slice(0, kb.maxResults || 3);
  }

  function money(n) {
    return "$" + Number(n).toLocaleString("en-US", { maximumFractionDigits: 0 });
  }

  // Returns the price text for one service, respecting sample mode.
  function priceText(svc, kb, showSamplePrices) {
    var hidePrices = kb.sample && !showSamplePrices;
    if (hidePrices || svc.low == null) return "Price confirmed on-site";
    var tax = kb.taxNote ? " " + kb.taxNote : "";
    if (svc.high == null || svc.high === svc.low) return money(svc.low) + tax;
    return money(svc.low) + "–" + money(svc.high) + tax;
  }

  var api = { normalize: normalize, estimate: estimate, priceText: priceText };
  root.OnsiteEstimator = api;
  if (typeof module !== "undefined" && module.exports) module.exports = api;
})(typeof window !== "undefined" ? window : globalThis);